const programsData = [
  // Travel and Tourism Department
  {
    id: 1,
    name: "Air Ticketing - Foundation Level 1",
    description: "Learn the basics of air ticketing and travel planning based on IATA/UFTAA syllabus.",
    duration: "9 months Diploma",
    learningOutcomes: [
      "Understand airfares, ticketing, and geography in travel planning.",
      "Develop skills in land, water transport, and tour packages.",
      "Gain knowledge of technology and customer service in travel.",
      "Apply practical skills in touristic attractions and operations."
    ],
  },
  {
    id: 2,
    name: "Air Ticketing - Consultant Level 2",
    description: "Advanced air ticketing and travel operations based on IATA/UFTAA syllabus.",
    duration: "6 months Diploma",
    learningOutcomes: [
      "Master advanced airfares, ticketing, and selling skills.",
      "Understand laws, regulations, and diverse transport modes.",
      "Develop expertise in tour packages and accommodation.",
      "Apply skills in complex travel operations and customer management."
    ],
  },
  {
    id: 3,
    name: "Cabin Crew/Inflight Attendant Duties",
    description: "Training for cabin crew roles with safety and service focus.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Learn safety procedures and emergency protocols.",
      "Develop customer service and in-flight service skills.",
      "Understand aviation regulations and crew coordination.",
      "Apply practical skills in simulated flight environments."
    ],
  },
  {
    id: 4,
    name: "Computerized Travel Operations",
    description: "Master computerized systems for travel operations.",
    duration: "3 months Certificate",
    learningOutcomes: [
      "Understand computerized reservation systems (e.g., Galileo).",
      "Develop skills in travel itinerary management.",
      "Gain knowledge of online travel tools and technologies.",
      "Apply skills in efficient travel operation workflows."
    ],
  },
  {
    id: 5,
    name: "Tour Guiding & Administration",
    description: "Master tour guiding with administrative skills.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Conduct safe and informative guided tours.",
      "Develop administrative and logistical planning skills.",
      "Understand cultural and safety protocols.",
      "Apply skills in tour management and customer interaction."
    ],
  },
  // Hospitality, Hotel and Catering Department
  {
    id: 6,
    name: "Front Office Operations and Administration",
    description: "Learn front office management and administration.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master front office procedures and guest services.",
      "Develop administrative and reservation skills.",
      "Understand hotel operations and customer relations.",
      "Apply skills in managing front desk operations."
    ],
  },
  {
    id: 7,
    name: "Housekeeping and Accommodation",
    description: "Training in housekeeping and accommodation management.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Learn housekeeping standards and cleaning techniques.",
      "Develop accommodation management skills.",
      "Understand safety and hygiene protocols.",
      "Apply skills in maintaining guest facilities."
    ],
  },
  {
    id: 8,
    name: "Hotel Management and Catering",
    description: "Comprehensive training in hotel and catering management.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master hotel management and catering operations.",
      "Develop skills in food service and guest relations.",
      "Understand financial and administrative aspects.",
      "Apply skills in managing hotel and catering services."
    ],
  },
  {
    id: 9,
    name: "Food and Beverage Service",
    description: "Training in food and beverage service principles.",
    duration: "9 months Diploma",
    learningOutcomes: [
      "Learn food and beverage service principles and practices.",
      "Develop skills in customer service and table management.",
      "Understand menu planning and beverage knowledge.",
      "Apply skills in professional dining service."
    ],
  },
  {
    id: 10,
    name: "Food Preparation and Cooking",
    description: "Master food preparation and cooking techniques.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Develop cooking techniques and food preparation skills.",
      "Understand kitchen safety and hygiene standards.",
      "Gain knowledge of culinary arts and recipes.",
      "Apply skills in professional kitchen environments."
    ],
  },
  {
    id: 11,
    name: "Culinary Arts",
    description: "Advanced training in culinary arts and patisserie.",
    duration: "6 months Advanced Diploma",
    learningOutcomes: [
      "Master culinary arts principles and patisserie techniques.",
      "Develop advanced cooking and baking skills.",
      "Understand food presentation and innovation.",
      "Apply skills in professional culinary settings."
    ],
  },
  {
    id: 12,
    name: "Diploma in Food & Beverage Management",
    description: "Management training for food and beverage operations.",
    duration: "18 months Diploma",
    learningOutcomes: [
      "Learn restaurant service and marketing strategies.",
      "Develop food and beverage management skills.",
      "Understand financial and operational aspects.",
      "Apply skills in managing food service operations."
    ],
  },
  {
    id: 13,
    name: "Diploma in Food Production",
    description: "Training in food production and culinary theory.",
    duration: "6 months Diploma",
    learningOutcomes: [
      "Master food production and culinary theory.",
      "Develop wine, bar, and catering law knowledge.",
      "Understand food safety and management practices.",
      "Apply skills in professional food production."
    ],
  },
  {
    id: 14,
    name: "Diploma in Patisserie",
    description: "Specialized training in patisserie techniques.",
    duration: "6 months Diploma",
    learningOutcomes: [
      "Master patisserie principles and practices.",
      "Develop skills in baking and dessert creation.",
      "Understand presentation and recipe innovation.",
      "Apply skills in professional patisserie settings."
    ],
  },
  // Business Department
  {
    id: 15,
    name: "Diploma in Business Studies",
    description: "Comprehensive business management training.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Understand business management and administration.",
      "Develop numerical and communication skills.",
      "Gain knowledge of business ethics and marketing.",
      "Apply skills in strategic business operations."
    ],
  },
  {
    id: 16,
    name: "Advanced Diploma in Business Studies",
    description: "Advanced training in business management.",
    duration: "6 months Advanced Diploma",
    learningOutcomes: [
      "Master business ethics and customer care.",
      "Develop advanced marketing management skills.",
      "Understand strategic business planning.",
      "Apply skills in complex business environments."
    ],
  },
  {
    id: 17,
    name: "Diploma in Management",
    description: "Training in management and customer service.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Learn customer service and strategic management.",
      "Develop leadership and organizational skills.",
      "Understand business strategy and operations.",
      "Apply skills in managing teams and projects."
    ],
  },
  {
    id: 18,
    name: "Diploma in Office Practice and Management",
    description: "Office administration and accounting skills.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master accounting and office procedures.",
      "Develop computer and communication skills.",
      "Understand international business practices.",
      "Apply skills in office management roles."
    ],
  },
  {
    id: 19,
    name: "Diploma in Purchasing and Supply Management",
    description: "Training in purchasing and supply chain management.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Understand international business communication.",
      "Develop quantitative methods and store management skills.",
      "Gain knowledge of stock control techniques.",
      "Apply skills in supply chain operations."
    ],
  },
  {
    id: 20,
    name: "Diploma in Sales and Marketing",
    description: "Training in sales and marketing strategies.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master principles and practice of selling.",
      "Develop business communication and economics skills.",
      "Understand marketing strategies and administration.",
      "Apply skills in sales and marketing campaigns."
    ],
  },
  {
    id: 21,
    name: "Diploma in Banking",
    description: "Training in banking principles and economics.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Understand elements of banking and economics.",
      "Develop communication and financial skills.",
      "Gain knowledge of banking operations.",
      "Apply skills in banking customer service."
    ],
  },
  {
    id: 22,
    name: "CPA I",
    description: "Certified Public Accountant Level I training.",
    duration: "5 months per level",
    learningOutcomes: [
      "Master financial accounting and economics.",
      "Develop skills in commercial law and taxation.",
      "Understand cost accounting principles.",
      "Apply skills in basic accounting practices."
    ],
  },
  {
    id: 23,
    name: "CPA II",
    description: "Certified Public Accountant Level II training.",
    duration: "5 months per level",
    learningOutcomes: [
      "Master business finance and information systems.",
      "Develop skills in commercial law and quantitative techniques.",
      "Understand advanced financial accounting.",
      "Apply skills in complex accounting scenarios."
    ],
  },
  {
    id: 24,
    name: "Diploma in Accounting and Finance",
    description: "Comprehensive accounting and finance training.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master bookkeeping and numerical accounting.",
      "Develop business management and law skills.",
      "Understand computer applications in finance.",
      "Apply skills in financial reporting and analysis."
    ],
  },
  {
    id: 25,
    name: "Advanced Diploma in Accounting and Finance",
    description: "Advanced training in accounting and finance.",
    duration: "12 months Advanced Diploma",
    learningOutcomes: [
      "Master financial management and auditing.",
      "Develop taxation and management skills.",
      "Understand advanced accounting practices.",
      "Apply skills in professional financial roles."
    ],
  },
  {
    id: 26,
    name: "Cargo Operations",
    description: "Training in cargo handling and logistics.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Understand cargo documentation and tariff classification.",
      "Develop skills in import/export procedures and warehousing.",
      "Gain knowledge of dangerous goods and insurance.",
      "Apply skills in cargo rating and air control."
    ],
  },
  {
    id: 27,
    name: "Diploma in Clearing & Forwarding",
    description: "Training in clearing and forwarding operations.",
    duration: "9 months Diploma",
    learningOutcomes: [
      "Master shipping economics and marine insurance.",
      "Develop skills in export/import practice and law.",
      "Understand customs declaration and air cargo services.",
      "Apply skills in logistics and forwarding operations."
    ],
  },
  {
    id: 28,
    name: "Diploma in Community Development",
    description: "Training in community development and empowerment.",
    duration: "6 months Diploma",
    learningOutcomes: [
      "Understand community development principles.",
      "Develop skills in resource mobilization and advocacy.",
      "Gain knowledge of social research and project management.",
      "Apply skills in community capacity building."
    ],
  },
  {
    id: 29,
    name: "Diploma in Social Works",
    description: "Training in social work and welfare practices.",
    duration: "12 months Diploma",
    learningOutcomes: [
      "Master social work theory and legal aspects.",
      "Develop counseling and rehabilitation skills.",
      "Understand disaster management and social policy.",
      "Apply skills in community social services."
    ],
  },
  {
    id: 30,
    name: "Advanced Diploma in Human Resource Development",
    description: "Advanced training in human resource management.",
    duration: "6 months Advanced Diploma",
    learningOutcomes: [
      "Master employee relations and training.",
      "Develop management theory and practice skills.",
      "Understand human resource development strategies.",
      "Apply skills in HR planning and development."
    ],
  },
  // Languages Department
  {
    id: 31,
    name: "Spanish Language",
    description: "Learn Spanish with a focus on conversational and cultural fluency.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master Spanish grammar, vocabulary, and conversational skills.",
      "Develop fluency for tourism and hospitality interactions.",
      "Gain insight into Spanish-speaking cultures and customs.",
      "Apply language skills in practical tourism settings."
    ],
  },
  {
    id: 32,
    name: "Italian Language",
    description: "Learn Italian with a focus on culture and communication.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Achieve proficiency in Italian grammar and conversational skills.",
      "Develop cultural fluency for tourism and hospitality.",
      "Understand Italian traditions and social norms.",
      "Apply language skills in real-world travel contexts."
    ],
  },
  {
    id: 33,
    name: "Sign Language",
    description: "Learn sign language for inclusive communication.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master basic and advanced sign language techniques.",
      "Develop skills for effective communication with deaf communities.",
      "Understand the cultural aspects of sign language use.",
      "Apply skills in inclusive tourism and hospitality settings."
    ],
  },
  {
    id: 34,
    name: "French Language",
    description: "Master French grammar, vocabulary, and conversational skills.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master French grammar, vocabulary, and conversational skills.",
      "Develop fluency for professional and tourism contexts.",
      "Understand French cultural and business norms.",
      "Apply language skills in diverse settings."
    ],
  },
  {
    id: 35,
    name: "English Language",
    description: "Master English grammar, vocabulary, and conversational skills.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master English grammar, vocabulary, and communication skills.",
      "Develop fluency for professional and tourism contexts.",
      "Understand English cultural and business norms.",
      "Apply language skills in diverse settings."
    ],
  },
  {
    id: 36,
    name: "German Language",
    description: "Learn German for tourism and business applications.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Achieve proficiency in German grammar and conversation.",
      "Develop skills for tourism and business interactions.",
      "Gain knowledge of German culture and etiquette.",
      "Apply language skills in practical contexts."
    ],
  },
  {
    id: 37,
    name: "Swahili Language",
    description: "Master Swahili for cultural and tourism engagement.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master Swahili grammar, vocabulary, and conversation.",
      "Develop fluency for tourism and cultural interactions.",
      "Understand Swahili cultural contexts.",
      "Apply language skills in local tourism settings."
    ],
  },
  {
    id: 38,
    name: "Japanese Language",
    description: "Master Japanese language skills for global opportunities.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master Japanese grammar, vocabulary, and conversational skills.",
      "Develop fluency for tourism and international business.",
      "Gain knowledge of Japanese culture and customs.",
      "Apply language skills in practical tourism scenarios."
    ],
  },
  {
    id: 39,
    name: "Chinese Language",
    description: "Learn Mandarin Chinese for tourism and hospitality.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Achieve proficiency in Mandarin Chinese grammar and vocabulary.",
      "Develop conversational skills for tourism and business interactions.",
      "Understand Chinese cultural practices and etiquette.",
      "Apply language skills in hospitality and travel contexts."
    ],
  },
  {
    id: 40,
    name: "Arabic Language",
    description: "Learn Arabic for tourism and cultural engagement.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Master Arabic grammar, vocabulary, and conversation.",
      "Develop fluency for tourism and cultural interactions.",
      "Understand Arabic cultural norms and practices.",
      "Apply language skills in relevant contexts."
    ],
  },
  {
    id: 41,
    name: "Local Vernaculars",
    description: "Master local languages for cultural engagement.",
    duration: "6 months accelerated (4 levels, 1.5 months each) / 12 months regular (4 levels, 3 months each)",
    learningOutcomes: [
      "Achieve proficiency in selected local vernacular languages.",
      "Develop conversational skills for cultural tourism.",
      "Gain insight into local customs and traditions.",
      "Apply language skills in community-based tourism."
    ],
  },
  // International College/University Entry Exams
  {
    id: 42,
    name: "TOEFL Preparation",
    description: "Preparation for TOEFL exam for university entry.",
    duration: "1 month",
    learningOutcomes: [
      "Master TOEFL test strategies and English skills.",
      "Develop reading, writing, listening, and speaking abilities.",
      "Understand exam format and time management.",
      "Apply skills to achieve competitive scores."
    ],
  },
  {
    id: 43,
    name: "GMAT Preparation",
    description: "Preparation for GMAT exam for graduate studies.",
    duration: "1 month",
    learningOutcomes: [
      "Master GMAT quantitative and verbal sections.",
      "Develop analytical writing and integrated reasoning skills.",
      "Understand exam structure and strategies.",
      "Apply skills to achieve high GMAT scores."
    ],
  },
  {
    id: 44,
    name: "GRE Preparation",
    description: "Preparation for GRE exam for graduate studies.",
    duration: "1 month",
    learningOutcomes: [
      "Master GRE verbal reasoning and quantitative skills.",
      "Develop analytical writing and critical thinking.",
      "Understand exam format and time management.",
      "Apply skills to achieve competitive GRE scores."
    ],
  },
  {
    id: 45,
    name: "SAT I Preparation",
    description: "Preparation for SAT I university entry exam.",
    duration: "1 month",
    learningOutcomes: [
      "Master SAT I math and evidence-based reading skills.",
      "Develop writing and language abilities.",
      "Understand exam structure and strategies.",
      "Apply skills to achieve high SAT scores."
    ],
  },
  {
    id: 46,
    name: "SAT II Preparation",
    description: "Subject-specific SAT II preparation.",
    duration: "1 month (varies by subject)",
    learningOutcomes: [
      "Master subject-specific content for SAT II.",
      "Develop advanced problem-solving skills.",
      "Understand exam format and preparation techniques.",
      "Apply skills to excel in chosen subjects."
    ],
  },
  {
    id: 47,
    name: "KCSE & GCE Upgrading",
    description: "Upgrading courses for KCSE and GCE subjects.",
    duration: "3 months per subject",
    learningOutcomes: [
      "Improve knowledge in selected KCSE/GCE subjects.",
      "Develop exam-specific skills and strategies.",
      "Understand subject content and application.",
      "Apply skills to achieve higher grades."
    ],
  },
  // Computer Department
  {
    id: 48,
    name: "Introduction to Computers (ICP1)",
    description: "Basic introduction to computer usage.",
    duration: "10 hours",
    learningOutcomes: [
      "Understand basic computer operations.",
      "Develop skills in using computer interfaces.",
      "Gain knowledge of hardware and software basics.",
      "Apply skills in basic computing tasks."
    ],
  },
  {
    id: 49,
    name: "MS-Windows (ICP1)",
    description: "Training in Windows operating system.",
    duration: "20 hours",
    learningOutcomes: [
      "Master Windows operating system navigation.",
      "Develop file management and system skills.",
      "Understand Windows security features.",
      "Apply skills in daily computer use."
    ],
  },
  {
    id: 50,
    name: "MS-Word (ICP2)",
    description: "Word processing with MS-Word.",
    duration: "20 hours",
    learningOutcomes: [
      "Master document creation and formatting.",
      "Develop advanced word processing skills.",
      "Understand templates and mail merge.",
      "Apply skills in professional document preparation."
    ],
  },
  {
    id: 51,
    name: "MS-Excel (ICP3)",
    description: "Spreadsheet management with MS-Excel.",
    duration: "20 hours",
    learningOutcomes: [
      "Master spreadsheet creation and analysis.",
      "Develop data management and charting skills.",
      "Understand formulas and functions.",
      "Apply skills in financial and data reporting."
    ],
  },
  {
    id: 52,
    name: "PowerPoint (ICP5)",
    description: "Presentation skills with PowerPoint.",
    duration: "10 hours",
    learningOutcomes: [
      "Master presentation design and delivery.",
      "Develop slide creation and animation skills.",
      "Understand effective presentation techniques.",
      "Apply skills in professional presentations."
    ],
  },
  {
    id: 53,
    name: "Keyboarding (ICP6)",
    description: "Improve typing and keyboard skills.",
    duration: "10 hours",
    learningOutcomes: [
      "Master touch typing techniques.",
      "Develop speed and accuracy in typing.",
      "Understand ergonomic keyboard use.",
      "Apply skills in efficient data entry."
    ],
  },
  {
    id: 54,
    name: "QuickBooks (ACC1)",
    description: "Accounting with QuickBooks software.",
    duration: "30 hours",
    learningOutcomes: [
      "Master QuickBooks accounting software.",
      "Develop financial recording skills.",
      "Understand bookkeeping and reporting.",
      "Apply skills in small business accounting."
    ],
  },
  {
    id: 55,
    name: "Sage - Accounting (ACC2)",
    description: "Accounting with Sage software.",
    duration: "30 hours",
    learningOutcomes: [
      "Master Sage accounting software.",
      "Develop financial management skills.",
      "Understand payroll and reporting.",
      "Apply skills in professional accounting tasks."
    ],
  },
  {
    id: 56,
    name: "CorelDRAW (DTP2)",
    description: "Graphic design with CorelDRAW.",
    duration: "30 hours",
    learningOutcomes: [
      "Master CorelDRAW graphic design tools.",
      "Develop vector illustration skills.",
      "Understand design principles.",
      "Apply skills in professional graphic projects."
    ],
  },
  {
    id: 57,
    name: "Adobe Illustrator (DTP4)",
    description: "Vector graphics with Adobe Illustrator.",
    duration: "30 hours",
    learningOutcomes: [
      "Master Adobe Illustrator vector tools.",
      "Develop advanced graphic design skills.",
      "Understand illustration techniques.",
      "Apply skills in professional design projects."
    ],
  },
  {
    id: 58,
    name: "Adobe Photoshop (DTP5)",
    description: "Image editing with Adobe Photoshop.",
    duration: "30 hours",
    learningOutcomes: [
      "Master Photoshop image editing tools.",
      "Develop photo manipulation skills.",
      "Understand digital imaging techniques.",
      "Apply skills in professional photo editing."
    ],
  },
  {
    id: 59,
    name: "Email & Internet (EIC)",
    description: "Training in email and internet usage.",
    duration: "10 hours",
    learningOutcomes: [
      "Master email communication and internet navigation.",
      "Develop online research skills.",
      "Understand internet security practices.",
      "Apply skills in professional online tasks."
    ],
  },
  {
    id: 60,
    name: "SPSS Statistical (SPSS)",
    description: "Statistical analysis with SPSS.",
    duration: "40 hours",
    learningOutcomes: [
      "Master SPSS statistical software.",
      "Develop data analysis and interpretation skills.",
      "Understand statistical methods and reporting.",
      "Apply skills in research and data-driven decisions."
    ],
  },
  {
    id: 61,
    name: "Other Group Computer Packages (CGP)",
    description: "Comprehensive computer package training.",
    duration: "Variable (group package)",
    learningOutcomes: [
      "Master multiple computer applications (Word, Excel, etc.).",
      "Develop integrated office skills.",
      "Understand software interoperability.",
      "Apply skills in professional office environments."
    ],
  },
  {
    id: 62,
    name: "AutoCAD (CAD1)",
    description: "Computer-aided design with AutoCAD.",
    duration: "40 hours",
    learningOutcomes: [
      "Master AutoCAD design and drafting tools.",
      "Develop 2D and 3D modeling skills.",
      "Understand technical drawing standards.",
      "Apply skills in architectural and engineering projects."
    ],
  },
  {
    id: 63,
    name: "ArchiCAD (CAD2)",
    description: "Architectural design with ArchiCAD.",
    duration: "40 hours",
    learningOutcomes: [
      "Master ArchiCAD architectural tools.",
      "Develop building design and modeling skills.",
      "Understand BIM (Building Information Modeling).",
      "Apply skills in architectural projects."
    ],
  },
  {
    id: 64,
    name: "HTML (Web1)",
    description: "Web design with HTML.",
    duration: "20 hours",
    learningOutcomes: [
      "Master HTML coding and structure.",
      "Develop basic web page design skills.",
      "Understand web development basics.",
      "Apply skills in creating simple websites."
    ],
  },
  {
    id: 65,
    name: "UNIX/LINUX User/Admin (NOS2)",
    description: "UNIX/LINUX system administration.",
    duration: "30 hours",
    learningOutcomes: [
      "Master UNIX/LINUX user and admin tasks.",
      "Develop system configuration skills.",
      "Understand command-line operations.",
      "Apply skills in Linux/UNIX environments."
    ],
  },
  {
    id: 66,
    name: "MS Office Suite (CC0)",
    description: "Comprehensive MS Office training.",
    duration: "Variable (group package)",
    learningOutcomes: [
      "Master MS Office applications (Word, Excel, etc.).",
      "Develop integrated office productivity skills.",
      "Understand advanced features of each tool.",
      "Apply skills in professional office tasks."
    ],
  },
  {
    id: 67,
    name: "Networking (City & Guilds) - Level 1 (0212)",
    description: "Basic networking training.",
    duration: "6 months (2 terms)",
    learningOutcomes: [
      "Understand computers and computing basics.",
      "Develop foundational networking skills.",
      "Gain knowledge of network concepts.",
      "Apply skills in basic network setups."
    ],
  },
  {
    id: 68,
    name: "Diploma in Computer Engineering (City & Guilds)",
    description: "Engineering training in computer systems.",
    duration: "6 months (2 terms)",
    learningOutcomes: [
      "Master electronic circuits and digital electronics.",
      "Develop microcomputer installation skills.",
      "Understand system maintenance and testing.",
      "Apply skills in computer engineering tasks."
    ],
  },
  {
    id: 69,
    name: "A+ Certification",
    description: "PC hardware and software support training.",
    duration: "Variable",
    learningOutcomes: [
      "Master PC fundamentals and software support.",
      "Develop hardware troubleshooting skills.",
      "Understand system maintenance practices.",
      "Apply skills in technical support roles."
    ],
  },
  {
    id: 70,
    name: "N+ Certification",
    description: "Network administration training.",
    duration: "Variable",
    learningOutcomes: [
      "Master network concepts and functions.",
      "Develop network administration skills.",
      "Understand network architecture and operations.",
      "Apply skills in solving network problems."
    ],
  },
];

export default programsData;